import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../Styles/CoverImageUploader.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaCamera } from "react-icons/fa"; // Importing camera icon
import ProfileImageUploader from "./CoverImageUploader";
import { right } from "@popperjs/core";
import { fetchFeedData } from "./MemberProfile/MemberProfileFetchData";
import { faUser } from "@fortawesome/free-solid-svg-icons";

const MpCoverImageUploader = ({ coverImage, setCoverImage, userId }) => {
  const navigate = useNavigate();
  const [feedData, setFeedData] = useState({});
  const [profileImage, setProfileImage] = useState("/assets/avatar/avatar-4.png");
  const [showDetail, setShowDetail] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [userStatus, setUserStatus] = useState("connected"); 
  // possible: connected | not_connected | request_sent | blocked

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setCoverImage(imageUrl);
    }
  };

  useEffect(() => {
    const loadFeedData = async () => {
      const data = await fetchFeedData();
      setFeedData(data);
      if (data?.status) setUserStatus(data.status);
    };
    loadFeedData();
  }, []);

  // ---- ICON COLOR ----
  const getUserColor = () => {
    switch (userStatus) {
      case "connected": return "green";
      case "not_connected": return "red";
      case "request_sent": return "orange";
      case "blocked": return "gray";
      default: return "black";
    }
  };

  // ---- MENU OPTIONS ----
  const getMenuOptions = () => {
    switch (userStatus) {
      case "connected":
        return [
          { label: "Disconnect", action: () => setUserStatus("not_connected") },
          { label: "Block User", action: () => setUserStatus("blocked") },
          { label: "Report Abuse", action: () => console.log("Reported abuse") },
          { label: "Hide User", action: () => console.log("User hidden") },
          { label: "More Info", action: () => setShowDetail(!showDetail) },
        ];
      case "not_connected":
        return [
          { label: "Connect", action: () => setUserStatus("request_sent") },
          { label: "Block User", action: () => setUserStatus("blocked") },
          { label: "Report Abuse", action: () => console.log("Reported abuse") },
          { label: "More Info", action: () => setShowDetail(!showDetail) },
        ];
      case "request_sent":
        return [
          { label: "Cancel Request", action: () => setUserStatus("not_connected") },
          { label: "Block User", action: () => setUserStatus("blocked") },
          { label: "Report Abuse", action: () => console.log("Reported abuse") },
          { label: "More Info", action: () => setShowDetail(!showDetail) },
        ];
      case "blocked":
        return [
          { label: "Unblock User", action: () => setUserStatus("not_connected") },
          { label: "More Info", action: () => setShowDetail(!showDetail) },
        ];
      default:
        return [];
    }
  };

  const handleDetail = () => {
    if (userStatus === "connected") {
      setShowDetail((prev) => !prev);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "row" }}>
      {/* Left Side - Profile Image */}
      <div className="mp-cover-container-left" style={{ justifyContent: "center", marginTop: 15 }}>
        <div>
          <img
            src={feedData.profileImage || profileImage}
            alt="Profile"
            className="mp-profile-photo"
            style={{ marginTop: 20 }}
          />
        </div>
      </div>

      {/* User Info */}
      <div className="mp-cover-container-User" style={{ borderRadius: 20, display: "flex", flexDirection: "row" }}>
        <FontAwesomeIcon
          icon={faUser}
          className="ua-icon-container"
          style={{
            width: 50,
            height: 40,
            marginBottom: 10,
            cursor: "pointer",
            color: getUserColor(),
          }}
          onClick={() => setMenuOpen(!menuOpen)}
        />
        <h3 style={{ fontSize: 50, marginLeft: 5 }}>{feedData.userId}</h3>

        {/* Dropdown Menu */}
        {menuOpen && (
          <div
            className="user-action-menu"
            style={{
              position: "relative",
              marginTop: 0,
              marginLeft: -400,
              backgroundColor: "gray",
              border: "1px solid #ccc",
              borderRadius: 8,
              padding: 10,
              zIndex: 1000,
              color: "black"
            }}
          >
            {getMenuOptions().map((option, index) => (
              <div
                key={index}
                onClick={() => {
                  option.action();
                  setMenuOpen(false);
                }}
                style={{
                  padding: "5px 10px",
                  cursor: "pointer",
                   borderBottom: index !== getMenuOptions().length - 1 ? "1px solid #eee" : "none",
                }}
              >
                {option.label}
              </div>
            ))}
          </div>
        )}
      </div>

      <div
  style={{
    marginTop: 100,
    display: "flex",
    flexDirection: "row",
    marginLeft: 50,
    borderRadius: 20,
    width: 500,
    height: 60,
  }}
>
  {/* Detail Button */}
  <button
    className="mp-cover-container-button"
    disabled={userStatus !== "connected"}
    onClick={handleDetail}
    style={{
      marginLeft: 100,
      marginTop: 5,
      fontFamily: "arial",
      fontWeight: "bold",
      backgroundColor: userStatus === "connected" ? "green" : "gray",
      color: "white",
      cursor: userStatus === "connected" ? "pointer" : "not-allowed",
    }}
  >
    Detail
  </button>

  {/* User Details (toggleable) */}
  {showDetail && (
    <div
      className="user-details-box"
      style={{ marginTop: -60, marginLeft: 50 }}
    >
      <p className="mp-user-text-props"> Location: {feedData.location}</p>
      <p className="mp-user-text-props"> Active: {feedData.activeLevel}</p>
      <p className="mp-user-text-props"> Created On: {feedData.createdOn}</p>
      <p className="mp-user-text-props"> Last Active: {feedData.lastActive}</p>
    </div>
  )}
</div>
    </div>
  );
};

export default MpCoverImageUploader;